export default __webpack_public_path__ + "static/implied-motion-fab-light-ade48533ee13efcbc2e400993d213595.mp4";